"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonRound = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_content_loader_1 = __importDefault(require("react-content-loader"));
const SkeletonRound = ({ widthFull = false, widthHalf = false, widthSmall = false, height = 20, ...rest }) => {
    const widthValue = widthFull ? 110 : (widthHalf ? 85 : (widthSmall ? 50 : 60));
    return ((0, jsx_runtime_1.jsx)(react_content_loader_1.default, { speed: 2, width: widthValue, height: height, viewBox: `0 0 ${widthValue} ${height}`, backgroundColor: 'rgb(var(--placeholder-secondary))', foregroundColor: 'rgb(var(--secondary-bg))', ...rest, children: (0, jsx_runtime_1.jsx)("rect", { x: "0", y: "0", rx: "10", ry: "10", width: "100%", height: height }) }));
};
exports.SkeletonRound = SkeletonRound;
